import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { UserIdentity } from "../../models/user-identity.model";
import { AuthService } from "../../services/auth.service";
import { AgentOrg } from "../../models/agentOrg.model";
import { Claim } from "../../admin/models/claim.model";
import { LoaderService } from "../../common/services/loader.service";


@Component({
    selector: 'app-select-organization',
    templateUrl: './select-organization.component.html',
    styleUrls: ['./select-organization.component.scss'],
    standalone: false
})
export class SelectOrganizationComponent implements OnInit, OnDestroy {

    subscription: Subscription = new Subscription();
    orgList: AgentOrg[] = [];
    constructor(private readonly router: Router, private readonly _auth: AuthService, private readonly loader: LoaderService) { }

    ngOnInit() {
        this.loader.toggleLoader(false);
        const userOrgs = sessionStorage.getItem("orgList");
        if (userOrgs) {
            this.processOrgs(userOrgs);
        } 

        if (this.orgList && this.orgList.length === 0) {
            this.loader.toggleLoader(true);
            let authObs$ = this._auth.setProfile().pipe().subscribe((identity: UserIdentity) => {
                this.loader.toggleLoader(false);
                let orgs = sessionStorage.getItem("orgList");
                this.processOrgs(orgs);
                console.log("auth complete");
            },
                (error) => {
                    this.loader.toggleLoader(false);
                    console.error(error);
                    this._auth.notFound(); //this isn't a great way of doing it, but angular doesn't handle redirects from the server before generating a subscription error
            });
            this.subscription.add(authObs$);
        }
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    private processOrgs(data: string): void {
        this.orgList = JSON.parse(data);
        if (this.orgList && this.orgList.length === 1) {
            this.viewSelectedOrg(this.orgList[0].orgId);
        }
    }

    private setPermissions(organization: string, contact: string, totalOrgs: number) {
        this.loader.toggleLoader(true); 
        let subs$ = this._auth.setPermissions(organization, contact, totalOrgs).subscribe(
            (claims: Claim[]) => {     
                this.loader.toggleLoader(false);
                this._auth.selectOrganization(organization);
                this._auth.redirectToDefaultDashboard();
            }, (error) => {
                this.loader.toggleLoader(false);
                console.error(error);
                this.router.navigate(["auth", "logout"]);
        });
        this.subscription.add(subs$);
    }

    viewSelectedOrg(id: string): void {
        if (id !== null) {
            let contactId = this.orgList.find(x => x.orgId === id).contactId;
            this.orgList = this.orgList.filter(x => x.orgId === id);
            sessionStorage.setItem("orgContactId", contactId);
            this.setPermissions(id, contactId, this.orgList.length);
        }

    }
}
